import { match } from 'ts-pattern'
import { CustomerOrderSystemVersion } from './customer-order-model'

export function getBehaviorForSystemVersion(version: CustomerOrderSystemVersion): CustomerOrderSystemBehavior {
  return match(version)
    .with('1', () => {
      return {
        selectReservationReimbursement: 'outOfBand',
        adHocDiscountOrderLineApplication: 'reservationLinesOnly',
        fullyDiscountedOrderLineFlatTaxStrategy: 'includeFlatTax',
        rideInsuranceDaysCalculation: 'calendarDays'
      } as const
    })
    .with('2', () => {
      return {
        selectReservationReimbursement: 'stripe',
        adHocDiscountOrderLineApplication: 'reservationLinesOnly',
        fullyDiscountedOrderLineFlatTaxStrategy: 'includeFlatTax',
        rideInsuranceDaysCalculation: 'calendarDays'
      } as const
    })
    .with('3', () => {
      return {
        selectReservationReimbursement: 'stripe',
        adHocDiscountOrderLineApplication: 'allLines',
        fullyDiscountedOrderLineFlatTaxStrategy: 'excludeFlatTax',
        rideInsuranceDaysCalculation: 'calendarDays'
      } as const
    })
    .with('4', () => {
      return {
        selectReservationReimbursement: 'stripe',
        adHocDiscountOrderLineApplication: 'allLines',
        fullyDiscountedOrderLineFlatTaxStrategy: 'excludeFlatTax',
        rideInsuranceDaysCalculation: 'billableDays'
      } as const
    })
    .exhaustive()
}

export interface CustomerOrderSystemBehavior {
  selectReservationReimbursement: 'stripe' | 'outOfBand'
  adHocDiscountOrderLineApplication: 'allLines' | 'reservationLinesOnly'
  fullyDiscountedOrderLineFlatTaxStrategy: 'includeFlatTax' | 'excludeFlatTax'
  rideInsuranceDaysCalculation: 'calendarDays' | 'billableDays'
}
